<template>
  <div id="main">
    <ScrollingMiniCharts @clicked="onMiniChartClicked"></ScrollingMiniCharts>
    
    <h1>Search Tickers</h1>

    <div class="searchbox">
      <input v-model="tickerInput" placeholder="GOOG AAPL FB ..." class="searchinput" type="text" name="tciker_input"/>
      <!-- <a-button v-on:click="updateTicker" class="searchbutton" /> -->
      <button v-on:click="updateTicker" class="searchbutton">Search</button>
    </div>


    <h1 v-if="ticker">{{ticker|uppercase}}</h1>

    <div id="selectedTickerView">
      <div class="pageRow">
        <div class="block">
          <PriceChart v-if="ticker" v-bind:ticker="ticker"/>
        </div>
        <!-- <div class="block">
          <PriceChartG v-if="ticker" v-bind:ticker="ticker"/>
        </div> -->
        <div class="block">
          <IndicatorsComponent v-if="ticker" v-bind:ticker="ticker"/>
        </div>
      </div>
      <br>
      <div class="pageRow">
        <CashFlowComponent v-if="ticker" v-bind:ticker="ticker"/>
      </div>
      <br>
      <div class="pageRow">
        <div class="block">
          <FinancialComponent v-if="ticker" v-bind:ticker="ticker"/>
        </div>
        <div class="block">
          <NewsComponent v-if="ticker" v-bind:ticker="ticker"/>
        </div>
      </div>
      <br>
      <div class="pageRow">
        <div class="block">
          <InfoComponent v-if="ticker" v-bind:ticker="ticker"/>
        </div>
        <div class="block">
          <SECFilingsComponent v-if="ticker" v-bind:ticker="ticker"/>
        </div>
        <!-- <div>
          <footer class="footer"/>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
// import footer from './footer.vue'
import PriceChart from './PriceChart.vue'
import InfoComponent from './InfoComponent.vue'
import FinancialComponent from './FinancialComponent.vue'
import CashFlowComponent from './CashFlowComponent.vue'
import ScrollingMiniCharts from './ScrollingMiniCharts.vue'
import NewsComponent from './NewsComponent.vue'
import SECFilingsComponent from './SECFilingsComponent.vue'
import IndicatorsComponent from './IndicatorsComponent.vue'
// import PriceChartG from './PriceChartGoogle.vue'

export default {
  name: 'MainComponent',
  components: {
    PriceChart,
    InfoComponent,
    FinancialComponent,
    CashFlowComponent,
    ScrollingMiniCharts,
    NewsComponent,
    SECFilingsComponent,
    IndicatorsComponent,
    // footer,
    // PriceChartG,
  },
  data () {
      return{
          ticker:null,
          tickerInput:null,
      }
  },
  methods: {
      updateTicker(){
        this.$gtag.event('search',{'search_term':this.tickerInput})
        this.ticker = this.tickerInput
      },
      onMiniChartClicked(value){
          this.tickerInput=value
          // this.ticker=value
          this.updateTicker()
      },
  },
  filters: {
      uppercase: function(s){
        return s.toUpperCase();
      },
  },
};
</script>

<style scoped>
#main {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
  margin-right: 60px;
  margin-left: 60px;
}
h1 {
  margin-bottom: 5px;
}

.block {
  height: 50%;
  width: 100%;
  max-width: 850px;
  display:inline-block;
  margin-bottom: 5px;
  margin-left: 5px;
  margin-top: 5px;
  margin-right: 5px;
  overflow: hidden;
  vertical-align: top;
  }

.longRow {
  width: 100%;
  float: center;
  margin-bottom: 5px;
  margin-top: 5px;
}
.pageRow {
  width: 100%;
  height: 50%;
  display:inline-block;
  overflow: hidden;
  vertical-align: top;

  margin-bottom: 5px;
  margin-left: 5px;
  margin-top: 5px;
  margin-right: 5px;
  
}
.card {
  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
  transition: 0.3s;
}

.card.greenCard {
      background-color: rgba(186, 228, 186, 0.3) !important;
      
  }

  .card.redCard {
    background-color: rgba(228, 187, 186, 0.3) !important;
    
  }

/* .searchbox{
  height:25px;
  width:300px;
  vertical-align: center;
  display:inline-block;
}
.searchinput{
  border:1px solid #BBBBBB;
  border-radius: 5px;
  border-color:#999999;
  height:100%;
}
.searchbutton{
  border:1px solid #BBBBBB;
  border-radius: 5px;
  border-color:#BBBBBB;
  height:115%;
} */

</style>
